module.exports = __webpack_public_path__ + "media/assets/images/mumc-logo-809fee7f6894dd7ec893d650b03220fd.png";